(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-element-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-element-guide')) {
 customElements.define('gg-element-guide', class extends HTMLElement {
  connectedCallback() {
   if(this.ready)return;this.ready=true;
   const tabs=[...this.querySelectorAll('[role="tab"]')];
   const select=(tab,focus=false)=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active;});if(focus)tab.focus();};
   tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();select(tabs[next],true);}});});
   this.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[role="tabpanel"]');if(panel)select(tabs.find(t=>t.getAttribute('aria-controls')===panel.id));});
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
